import { render, staticRenderFns } from "./JingquZiyuanFenxiDetail.vue?vue&type=template&id=4727cbf3&scoped=true&"
import script from "./JingquZiyuanFenxiDetail.vue?vue&type=script&lang=js&"
export * from "./JingquZiyuanFenxiDetail.vue?vue&type=script&lang=js&"
import style0 from "./JingquZiyuanFenxiDetail.vue?vue&type=style&index=0&id=4727cbf3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4727cbf3",
  null
  
)

export default component.exports